import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AssetCategoryReducer } from '../reducers';

export const selectAssetCategoryFeature = createFeatureSelector<AssetCategoryReducer.AssetCategoryState>(AssetCategoryReducer.featureName);

export const selectAssetCategory = createSelector(selectAssetCategoryFeature, (state: AssetCategoryReducer.AssetCategoryState) => state.item);
